import { Component } from '@angular/core';
import { IonicPage, AlertController, ToastController, NavController, NavParams } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { LoginPage } from './../login/login';

/**
 * Generated class for the ServerDetailsNewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-server-details-new',
  templateUrl: 'server-details-new.html',
})
export class ServerDetailsNewPage {
  private storage: Storage;
  svrName = { servername: '' };
  lstServer: Array<any>;
  dataserver = '';
  txtserver = '';
  txtservername = '';

  constructor(public navCtrl: NavController, storage: Storage, public navParams: NavParams,
    private toastCtrl: ToastController, private alertCtrl: AlertController) {
    this.lstServer = [];
    this.storage = storage;
    this.storage.get('ServerName').then((sDetails) => {
        this.svrName.servername = sDetails;
    });

    this.storage.get('ServerList').then((sDetails) => {
      this.dataserver = sDetails;
      this.fillListServer();
  });
  }

  fillListServer() {
    if(this.dataserver) {
      this.lstServer = this.dataserver.split(',');
    }
  }
  saveServer() {
    if(this.txtserver != '') {
      if(this.txtservername != '') {
        //console.log(this.txtserver);
        this.lstServer.push(this.txtserver+';'+this.txtservername);
        //console.log(this.lstServer.join(','));
        this.storage.set('ServerList', this.lstServer.join(','));
      }

    }

    this.txtserver ='';
    this.txtservername = '';
  }
  itemTapped(event, detail) {
    var dd = detail.split(';');
    this.storage.set('ServerName', dd[0]);
    this.storage.set('ServerName2', dd[1]);
    let toast = this.toastCtrl.create({
      message: 'Connected to '+dd[0],
      duration: 3000,
      position: 'bottom'
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed');
    });

    toast.present();
    this.navCtrl.setRoot(LoginPage);
  }
  deleteItem(detail) {
    let alert = this.alertCtrl.create({
      title: 'Confirm remove',
      message: 'Remove '+detail+'?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            console.log('No clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            console.log('Yes clicked');
            var index = this.lstServer.indexOf(detail);
            //remove from array
            this.lstServer.splice(index, 1);
            //Save into db
            this.storage.set('ServerList', this.lstServer.join(','));
          }
        }
      ]
    });
    alert.present();

    // for(let i=0;i< this.lstServer.length;i++) {

    // }
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad ServerDetailsNewPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/server-details-new/server-details-new.ts